import axios from 'axios';
import axiosInstance from '../utils/axiosInstance';
// import axios from "axios";
import { BlobServiceClient } from '@azure/storage-blob';

//to generate guid id
const generateGUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const baseurl = process.env.REACT_APP_API;
const baseurlauth = process.env.REACT_APP_DB_LOGIN_API;
const enrichUrl = process.env.REACT_APP_ENRICHMENT_API;
const sasUrl = process.env.REACT_APP_AZURE_STORAGE_SAS_URL;
const containerName = process.env.REACT_APP_AZURE_STORAGE_CONTAINER_NAME;
const staiApi = process.env.REACT_APP_STAI_API;

const apiServices = {
  loginJwt: (data) => {
    return axiosInstance.post(`${baseurl}/auth/login`, data).then((res) => res.data);
  },

  signupJwt: (data) => {
    return axiosInstance.post(`${baseurl}/auth/signup`, data).then((res) => res.data);
  },

  forgotPassword: (email) => {
    return axiosInstance.post(`${baseurl}/auth/forgot-password`, { email });
  },

  getBlobImage: async (imgUrl) => {
    const blobServiceClient = new BlobServiceClient(sasUrl);

    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blobClient = containerClient.getBlobClient(imgUrl);

    const downloadBlockBlobResponse = await blobClient.download(0);
    const blobContent = await downloadBlockBlobResponse.blobBody;

    // Convert blob content to a URL for display
    const objectURL = URL.createObjectURL(blobContent);
    return objectURL;
  },

  // getProjectTaskStatus: (data) => {
  //   // const correlationId = apiServices.generateGUID();
  //   // const requestId = apiServices.generateGUID();
  //   const apiUrl = `${baseurl}/Assignment/GetByProjectId?ProjectId=` + data;

  //   // return axios.get(apiUrl, {
  //   //     headers: {
  //   //       'Authorization': 'Bearer ' + tokenStr,
  //   //       'X-Correlation-Id': correlationId,
  //   //       'X-Request-Id': requestId,
  //   //     },
  //   //   });
  //   return axiosInstance.get(apiUrl);
  // },

  // getProjectOverdueWorkItems: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/GetByProjectId?ProjectId=` + data;
  //   return axiosInstance.get(apiUrl);
  // },
  // getProjectList: (data) => {
  //   let apiUrl = `${baseurl}/Project/GetMasterProjects`;
  //   //if (data)
  //   //apiUrl = `${baseurl}/Project/GetProjects?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&OrderType=${data.OrderType}&ColumnName=${data.ColumnName}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getSortedProjectList: (data) => {
  //   const apiUrl = `${baseurl}/Project/GetProjects?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&OrderType=${data.OrderType}&ColumnName=${data.ColumnName}&IsDashboard=${data.IsDashboard}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getActiveProjectList: (data) => {
  //   const apiUrl = `${baseurl}/Project/GetProjects?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&OrderType=${data.OrderType}&ColumnName=${data.ColumnName}&StatusType=${data.statusType}&IsDashboard=${data.IsDashboard}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getProjectByProjectId: (data) => {
  //   const apiUrl = `${baseurl}/Project/GetProjects?ProjectId=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getActiveClientList: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetClientCount?Inactiveclient=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getInActiveClientList: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetClientCount?Inactiveclient=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getDashboardActiveProjectCount: (data) => {
  //   const apiUrl = `${baseurl}/dashboard/GetActiveProjectCount?userid=${data.userId}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getTaskList: () => {
  //   const apiUrl = `${baseurl}/Assignment/GetAssignments`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getSortedTaskList: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/GetAssignments?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&OrderType=${data.OrderType}&ColumnName=${data.ColumnName}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getOverdueTaskListDashboard: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/GetAssignments?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&OrderType=${data.OrderType}&ColumnName=${data.ColumnName}&IsOverdueDashboard=${data.IsOverdueDashboard}&projectId=${data.projectID}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getDeadlineTaskListDashboard: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/GetAssignments?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&OrderType=${data.OrderType}&ColumnName=${data.ColumnName}&AssignmentId=${data.assignmentId}&IsDeadlineDashboard=${data.IsDeadlineDashboard}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getOverdueTaskList: (data) => {
  //   const apiUrl = `${baseurl}/dashboard/GetOverdueAssignmentsCount?userId=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },
  getGenericMasterFilteredList: (data) => {
    const apiUrl = `${baseurl}/Master/GetFilteredGenericMasterTable`;
    return axiosInstance.post(apiUrl, data);
  },
  // getStatusList: () => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=Status`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getDurationChangeReasonList: () => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=ProjectDurationChangeReason`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getProjectBillingTypeList: () => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?group=ProjectBilling`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getProjectBillingModelList: (data) => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?parentId=${data}&type=ProjectBillingModel`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getAssignmentBillingTypeList: (data) => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?parentId=${data}&type=AssignmentBillingType`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getAssignmentBillingStatusList: (data) => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?group=AssignmentBilling`;
  //   return axiosInstance.get(apiUrl);
  // },

  // getProjectType: () => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=ProjectType`;
  //   return axiosInstance.get(apiUrl);
  // },

  getProjectTypeCrm: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=ProjectTypeCrm`;
    return axiosInstance.get(apiUrl);
  },

  // getPriorityList: () => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=Priority`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getTaskTagList: () => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=TaskTag`;
  //   return axiosInstance.get(apiUrl);
  // },
  getUserList: () => {
    const apiUrl = `${baseurl}/NetAuth/GetUsersAsync`;
    return axiosInstance.get(apiUrl);
  },
  // getFlagList: () => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=Flag`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getMilestoneList: () => {
  //   const apiUrl = `${baseurl}/Milestone/GetMilestones`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getMilestoneById: (data) => {
  //   const apiUrl = `${baseurl}/Milestone/GetById?id=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getNotificationRuleList: () => {
  //   const apiUrl = `${baseurl}/TimetrackNotification/GetNotificationRules`;
  //   return axiosInstance.get(apiUrl);
  // },
  // updateNotificationRule: (data) => {
  //   const apiUrl = `${baseurl}/TimetrackNotification/UpdateNotificationRule`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getNotificationUserSubscriptionList: (data) => {
  //   const apiUrl = `${baseurl}/TimetrackNotification/GetNotificationUserSubscriptions`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // upsertNotificationUserSubscriptionList: (data) => {
  //   const apiUrl = `${baseurl}/TimetrackNotification/UpsertNotificationUserSubscription`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getSortedMilestoneList: (data) => {
  //   const apiUrl = `${baseurl}/Milestone/GetMilestones?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&OrderType=${data.OrderType}&ColumnName=${data.ColumnName}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // updateMilestone: (data) => {
  //   const apiUrl = `${baseurl}/Milestone/Update`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // createMilestone: (data) => {
  //   const apiUrl = `${baseurl}/Milestone/Create`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // deleteMilestone: (data) => {
  //   const apiUrl = `${baseurl}/Milestone/Delete`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // getRecentTasksByUserId: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetRecentAssignments?userId=${data}`;
  //   return axiosInstance.get(apiUrl, data);
  // },
  // getGroupList: () => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=Group`;
  //   return axiosInstance.get(apiUrl);
  // },

  // getCustomConfig: () => {
  //   const apiUrl = `${baseurl}/Config/GetCustomConfigList`;
  //   return axiosInstance.get(apiUrl);
  // },

  // getClientList: (order) => {
  //   let apiUrl;
  //   if (order) {
  //     apiUrl = `${baseurl}/Client/GetClients?columnName=DisplayName&orderType=${order}`;
  //   } else {
  //     apiUrl = `${baseurl}/Client/GetClients`;
  //   }
  //   return axiosInstance.get(apiUrl);
  // },

  // getBillableType: (data) => {
  //   let apiUrl;
  //   if (data) {
  //     apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=${data}`;
  //     // apiUrl = `https://nettime.azurewebsites.net/api/Master/GetGenericMasterTable?type=${data}`;
  //   } else {
  //     apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=BillingType`;
  //     // apiUrl = `https://nettime.azurewebsites.net/api/Master/GetGenericMasterTable?type=BillingType`;
  //   }
  //   return axiosInstance.get(apiUrl);
  // },
  // getClientListByDashBoard: (status) => {
  //   let apiUrl = `${baseurl}/Client/GetClients?Inactiveclient=${status.dashboardStatus}&IsDashboard=${status.IsDashboard}`;
  //   // if (order)
  //   //   apiUrl = `${baseurl}/Client/GetClients?columnName=DisplayName&orderType=${order}`;
  //   return axiosInstance.get(apiUrl);
  // },

  getUserDetail: (data) => {
    // const apiUrl = `${baseurlauth}/User/GetUserById?userId=${data}`;
    const apiUrl = `${baseurl}/NetAuth/GetUserVmByUserName?userName=${data}`;
    return axiosInstance.get(apiUrl, {
      headers: {
        'X-Correlation-Id': generateGUID(),
        'X-Request-Id': generateGUID(),
      },
    });
  },

  getUserActivity: (data) => {
    const apiUrl = `${baseurl}/NetAuth/UserActivities?userId=${data?.userId}&pageSize=${data?.pageSize}&pageNumber=${data?.pageNumber}`;
    return axiosInstance.get(apiUrl);
  },

  // getAssociateRM: () => {
  //   const apiUrl = `${baseurl}/AssociateRM/GetAssociateRM`;
  //   return axiosInstance.get(apiUrl);
  // },

  // getMasterConfigListForUsers: (data) => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },

  // associateUserDetails: (data) => {
  //   const apiUrl = `${baseurl}/AssociateRm/UserDetail`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // associateRmUserDetailsById: (data) => {
  //   const apiUrl = `${baseurl}/AssociateRm/GetAssociateRm?UserId=${data}`;
  //   return axiosInstance.get(apiUrl, data);
  // },

  getUserDetailByMailOrOid: (email, id) => {
    // const apiUrl = `${baseurlauth}/User/GetUserVmByUserName?userName=${email}`;
    const apiUrl = `${baseurl}/NetAuth/GetUserVmByUserName?userName=${email}`;

    // return axios.get(apiUrl, {
    //   headers: {
    //     "X-Correlation-Id": generateGUID(),
    //     "X-Request-Id": generateGUID(),
    //   },
    // });
    return axiosInstance.get(apiUrl);
  },
  // createGroupAssignment: (data) => {
  //   const apiUrl = `${baseurl}/GroupAssignments/Create`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // getGroupAssignmentName: (projectId) => {
  //   const apiUrl = `${baseurl}//GroupAssignments/GetGroupAssignmentByProjectId?ProjectId=${projectId}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getTimesheetByProjectId: (projectId) => {
  //   const apiUrl = `${baseurl}//Timesheet/GetTimesheetsByProjectId?ProjectId=${projectId}`;
  //   return axiosInstance.get(apiUrl);
  // },

  // updateGroupAssignment: (data) => {
  //   const apiUrl = `${baseurl}/GroupAssignments/Update`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // createClient: (data) => {
  //   const apiUrl = `${baseurl}/Client/Create`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // updateClient: (data) => {
  //   const apiUrl = `${baseurl}/Client/Update`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // deleteClient: (data) => {
  //   const apiUrl = `${baseurl}/Client/Delete`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // getTimesheetList: () => {
  //   const apiUrl = `${baseurl}/Timesheet/GetTimesheets?OrderType=desc&ColumnName=timesheetDate`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getTimesheetById: (data) => {
  //   const apiUrl = `${baseurl}/Timesheet/GetById?id=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getSortedTimesheetList: (data) => {
  //   const apiUrl = `${baseurl}/Timesheet/GetTimesheets?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&OrderType=${data.OrderType}&ColumnName=${data.ColumnName}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getTaskListByProject: (data) => {
  //   const projectIdTask = data;
  //   const apiUrl =
  //     `${baseurl}/Assignment/GetByProjectId?ProjectId=` + projectIdTask;
  //   return axiosInstance.get(apiUrl);
  // },
  // getProjectListByClient: (data) => {
  //   const clientIdProject = data;
  //   const apiUrl =
  //     `${baseurl}/Project/GetProjectByClientId?id=` + clientIdProject;
  //   return axiosInstance.get(apiUrl);
  // },
  // getProjectAssignmentByClient: (data) => {
  //   const apiUrl = `${baseurl}/Project/GetFilteredListByClientId?id=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getTimesheetListByDate: (date, userId) => {
  //   const apiUrl = `${baseurl}/DailyLog/GetTimesheetsByDate?TimesheetDate=${date}&OwnerId=${userId}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getEventList: (userId) => {
  //   const userIds = {"OwnerId" : userId }
  //   const apiUrl = `${baseurl}/DailyLog/GetTimeByMonth?OwnerId`; // Explicitly set OwnerId to null
  //   return axiosInstance.post(apiUrl, userIds);
  // },
  // updateTask: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/Update`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // createTask: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/Create`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // deleteTask: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/Delete`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getTaskById: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/GetById?id=${data}`;
  //   return axiosInstance.get(apiUrl, data);
  // },
  // getRecentTasksByUserId: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetRecentAssignments?userId=${data}`;
  //   return axiosInstance.get(apiUrl, data);
  // },
  // updateProject: (data) => {
  //   const apiUrl = `${baseurl}/Project/Update`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // createProject: (data) => {
  //   const apiUrl = `${baseurl}/Project/Create`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // deleteProject: (data) => {
  //   const apiUrl = `${baseurl}/Project/Delete`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // updateTimeSheet: (data) => {
  //   const apiUrl = `${baseurl}/Timesheet/Update`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // createTimeSheet: (data) => {
  //   const apiUrl = `${baseurl}/Timesheet/Create`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // createWeeklyTimeSheet: (data) => {
  //   const apiUrl = `${baseurl}/Timesheet/CreateWeeklyTimesheet`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getDashboardTask: (data) => {
  //   const apiUrl = `${baseurl}/dashboard/GetAssignmentAndMilestoneStatusCount?userid=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },

  // getDashboardActiveTask: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/GetAssignments?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&OrderType=${data.OrderType}&ColumnName=${data.ColumnName}&StatusType=${data.statusType}&IsDashboard=${data.IsDashboard}`;
  //   return axiosInstance.get(apiUrl);
  // },

  // getDashboardActiveMilestone: (data) => {
  //   const apiUrl = `${baseurl}/Milestone/GetMilestones?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&OrderType=${data.OrderType}&ColumnName=${data.ColumnName}&StatusType=${data.statusType}&IsDashboard=${data.IsDashboard}`;
  //   return axiosInstance.get(apiUrl);
  // },

  // getTaskDeadlineList: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetAssignmentDeadline?userId=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },

  // getAssignmentDeadlineByProjectId: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetAssignmentDeadline?userId=${data.userId}&ProjectId=${data.projectID}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getMonthSummaryReport: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetMonthSummaryReport?Year=${data.year}&Month=${data.month}`;
  //   return axiosInstance.get(apiUrl, data);
  // },
  // getReportTimesheetsDateView: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetTimesheetsDateView`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getReportTimesheetsReport: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetTimesheetsReport`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getReportTimesheetsReportOnBehalfOfUserId: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetTimesheetsReportOnBehalfOfUserId`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getReportResourceAllocationReport: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetResourceAllocationReportListQuery`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getReportResourceAllocationReportDate: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetResourceAllocationReportListQuery`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getReportHRFinanceReport: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetHrReportListQuery`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getReportHRFinanceReportDate: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetHrReportDateViewList`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getReportFilter: (data) => {
  //   const apiUrl = `${baseurl}/Dashboard/GetReportFilter`;
  //   return axiosInstance.get(apiUrl);
  // },

  // callChatbot: (data) => {
  //   const apiUrl = `https://itdemos.kmgin.com:5000/receive_id`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // getCopyFromYesterday: (OwnerId) => {
  //   const apiUrl = `${baseurl}/Timesheet/CopyFromYesterday?OwnerId=${OwnerId}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getUserLogHours: (userId) => {
  //   const apiUrl = `${baseurl}/Timesheet/GetUserLogHoursByOwnerId?OwnerId=${userId}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getUserLogHoursByProjectId: (data) => {
  //   const apiUrl = `${baseurl}/Timesheet/GetUserLogHoursByOwnerId?OwnerId=${data.userId}&ProjectId=${data.projectID}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getUnfilledTimesheetDate: (OwnerId) => {
  //   const apiUrl = `${baseurl}/Timesheet/GetUnfilledTimesheetDateByOwnerId?ownerId=${OwnerId}`;
  //   return axiosInstance.get(apiUrl);
  // },
  getUserSettings: () => {
    const apiUrl = `${baseurl}/UserSetting/GetUserSettings`;
    return axiosInstance.get(apiUrl);
  },

  updateUserSettings: (data) => {
    const apiUrl = `${baseurl}/UserSetting/Update`;
    return axiosInstance.post(apiUrl, data);
  },
  getUserManagementList: () => {
    // const apiUrl = `${baseurlauth}/User/GetUsersAsync`;
    const apiUrl = `${baseurl}/NetAuth/GetUsersAsync`;
    return axiosInstance.get(apiUrl);
  },
  getRoleList: () => {
    // const apiUrl = `${baseurlauth}/Auth/Roles`;
    const apiUrl = `${baseurl}/NetAuth/Roles`;

    return axiosInstance.get(apiUrl);
  },

  getPermissionsByRole: (data) => {
    // const apiUrl = `${baseurlauth}/User/GetPermissionsByRoleId?roleId=` + data;
    const apiUrl = `${baseurl}/NetAuth/GetPermissionsByRoleId?roleId=` + data;

    return axiosInstance.get(apiUrl);
  },

  getPermissionGroup: () => {
    // const apiUrl = `${baseurlauth}/Auth/PermissionsAsync`;
    const apiUrl = `${baseurl}/NetAuth/PermissionsAsync`;
    return axiosInstance.get(apiUrl);
  },

  createUser: (data) => {
    // const apiUrl = `${baseurlauth}/User/AddUser`;
    const apiUrl = `${baseurl}/NetAuth/AddUser`;
    return axiosInstance.post(apiUrl, data);
  },
  updateUser: (data) => {
    // const apiUrl = `${baseurlauth}/User/UpdateUser`;
    const apiUrl = `${baseurl}/NetAuth/UpdateUser`;
    return axiosInstance.post(apiUrl, data);
  },
  clearNetAuthCache: () => {
    // const apiUrl = `${baseurlauth}/User/ResetUserObjectCache`;
    const apiUrl = `${baseurl}/NetAuth/ResetUserObjectCache`;
    return axiosInstance.put(apiUrl);
  },
  clearNetTimeCache: () => {
    const apiUrl = `${baseurl}/NetAuth/ResetUserObjectCache`;
    return axiosInstance.put(apiUrl);
  },
  savePermissionsByRole: (data) => {
    // const apiUrl = `${baseurlauth}/User/AddPermissionsForRole`;
    const apiUrl = `${baseurl}/NetAuth/AddPermissionsForRole`;
    return axiosInstance.post(apiUrl, data);
  },
  manageUserRoles: (data) => {
    // const apiUrl = `${baseurlauth}/user/AddRoles`;
    const apiUrl = `${baseurl}/NetAuth/AddRoles`;
    return axiosInstance.post(apiUrl, data);
  },
  // manageUpsetUserRoles: (data) => {
  //   const apiUrl = `${baseurl}/NetAuth/UpsertUserInCacheAsync`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  getPermissionList: () => {
    // const apiUrl = `${baseurlauth}/Auth/PermissionsAsync`;
    const apiUrl = `${baseurl}/NetAuth/PermissionsAsync`;
    return axiosInstance.get(apiUrl);
  },

  getPermissionGroupList: () => {
    // const apiUrl = `${baseurlauth}/User/GetPermissionGroups`;
    const apiUrl = `${baseurl}/NetAuth/GetPermissionGroups`;
    return axiosInstance.get(apiUrl);
  },

  getPermissionModuleList: () => {
    // const apiUrl = `${baseurlauth}/User/GetAuthReferenceLookupsByTypeName?type=Module`;
    const apiUrl = `${baseurl}/NetAuth/GetAuthReferenceLookupsByTypeName?type=Module`;

    return axiosInstance.get(apiUrl);
  },

  getPermissionSetList: () => {
    // const apiUrl = `${baseurlauth}/User/GetAuthReferenceLookupsByTypeName?type=PermissionSet`;
    const apiUrl = `${baseurl}/NetAuth/GetAuthReferenceLookupsByTypeName?type=PermissionSet`;

    return axiosInstance.get(apiUrl);
  },

  getUnListedPermissions: () => {
    const apiUrl = `${baseurl}/SystemManager/GetUnlistedRequestAndQueryNameList`;
    return axiosInstance.get(apiUrl);
  },

  updatePermissions: (data) => {
    // const apiUrl = `${baseurlauth}/User/UpdatePermission`;
    const apiUrl = `${baseurl}/NetAuth/UpdatePermission`;
    return axiosInstance.post(apiUrl, data);
  },

  createPermissions: (data) => {
    // const apiUrl = `${baseurlauth}/User/AddPermission`;
    const apiUrl = `${baseurl}/NetAuth/AddPermission`;
    return axiosInstance.post(apiUrl, data);
  },

  // addAssociateUsersProject: (data) => {
  //   const apiUrl = `${baseurl}/Project/AddProjectUsers`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // getProjectbyId: (data) => {
  //   const apiUrl = `${baseurl}/Project/GetById?id=` + data;
  //   return axiosInstance.get(apiUrl, data);
  // },

  // getMasterConfigList: (data) => {
  //   const apiUrl = `${baseurl}/Config/GetCustomConfigList`;
  //   return axiosInstance.get(apiUrl, data);
  // },

  // addMasterConfigData: (data) => {
  //   const apiUrl = `${baseurl}/Config/CreateConfig`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // updateMasterConfigData: (data) => {
  //   const apiUrl = `${baseurl}/Config/UpdateConfig`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // addCustomUIConfig: (data) => {
  //   const apiUrl = `${baseurl}/CustomFields/Create`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // getCustomConfigModuleList: () => {
  //   const apiUrl = `${baseurl}/CustomFields/GetEntityNameFromReferenceCustomField`;
  //   return axiosInstance.get(apiUrl);
  // },

  // getCustomFieldsByEntity: (data) => {
  //   const apiUrl =
  //     `${baseurl}/CustomFields/GetCustomFieldByEntity?name=` + data;
  //   return axiosInstance.get(apiUrl);
  // },
  // getConfigByComponentIdAndDivId: (compId) => {
  //   const apiUrl = `${baseurl}/Config/GetConfigByComponentIdAndDivId?&componentID=${compId}`;
  //   return axiosInstance.get(apiUrl);
  // },

  // addCustomFieldConfig: (data) => {
  //   const apiUrl = `${baseurl}/CustomFields/Create`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // updateCustomFieldConfig: (data) => {
  //   const apiUrl = `https://nettime.azurewebsites.net/api/CustomFields/Create`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // deleteCustomFieldConfig: (data) => {
  //   const apiUrl = `${baseurl}/CustomFields/Delete`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  getUiPermissionList: (data) => {
    // const apiUrl = `${baseurlauth}/Auth/UiPermissions`;
    const apiUrl = `${baseurl}/NetAuth/UiPermissions`;

    return axiosInstance.get(apiUrl, data);
  },

  getUiPermissionsModule: () => {
    // const apiUrl = `${baseurlauth}/User/GetAuthReferenceLookupsByTypeName?type=Module`;
    const apiUrl = `${baseurl}/NetAuth/GetAuthReferenceLookupsByTypeName?type=Module`;

    return axiosInstance.get(apiUrl);
  },
  getUiPermissionsParent: () => {
    // const apiUrl = `${baseurlauth}/Auth/uipermissions`;
    const apiUrl = `${baseurl}/NetAuth/UiPermissions`;

    return axiosInstance.get(apiUrl);
  },
  addUiPermissions: (data) => {
    // const apiUrl = `${baseurlauth}/user/AddUiPermission`;
    const apiUrl = `${baseurl}/NetAuth/AddUiPermission`;

    return axiosInstance.post(apiUrl, data);
  },
  updateUiPermissions: (data) => {
    // const apiUrl = `${baseurlauth}/user/UpdateUiPermission`;
    const apiUrl = `${baseurl}/NetAuth/UpdateUiPermission`;

    return axiosInstance.post(apiUrl, data);
  },

  // getModuleHistory: (data) => {
  //   const apiUrl = `${baseurl}/ModuleHistory/GetModuleHistoryById?entityId=${data.entityID}&entityType=${data.entityName}`;
  //   return axiosInstance.get(apiUrl, data);
  // },
  getUiPermissions: () => {
    // const apiUrl = `${baseurlauth}/Auth/UiPermissions`;
    const apiUrl = `${baseurl}/NetAuth/UiPermissions`;

    return axiosInstance.get(apiUrl);
  },

  getUiPermissionsByRoleId: (roleId) => {
    // const apiUrl = `${baseurlauth}/User/GetUiPermissionsByRoleId?roleId=${roleId}`;
    const apiUrl = `${baseurl}/NetAuth/GetUiPermissionsByRoleId?roleId=${roleId}`;

    return axiosInstance.get(apiUrl);
  },

  saveUiPermissionsByRole: (data) => {
    // const apiUrl = `${baseurlauth}/User/AddUiPermissionsForRole`;
    const apiUrl = `${baseurl}/NetAuth/AddUiPermissionsForRole`;

    return axiosInstance.post(apiUrl, data);
  },

  // addTimesheetApproval: (data) => {
  //   const apiUrl = `${baseurl}/Timesheet/UpdateTimesheetApprovalStatus`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // updateTimesheetBillingType: (data) => {
  //   const apiUrl = `${baseurl}/Timesheet/UpdateTimesheetBillingType`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  getUiPermissionsType: () => {
    // const apiUrl = `${baseurlauth}/User/GetAuthReferenceLookupsByTypeName?type=uipermissionType`;
    const apiUrl = `${baseurl}/NetAuth/GetAuthReferenceLookupsByTypeName?type=UIPermissionType`;

    return axiosInstance.get(apiUrl);
  },

  // getUIPermissionAttributeLookup: () => {
  //   // const apiUrl = `${baseurlauth}/User/GetMasterUiPermissions`;
  //   const apiUrl = `${baseurl}/NetAuth/GetMasterUiPermissions`;

  //   return axiosInstance.get(apiUrl);
  // },

  // addMasterUiPermissions: (data) => {
  //   // const apiUrl = `${baseurlauth}/User/AddMasterUiPermission`;
  //   const apiUrl = `${baseurl}/NetAuth/AddMasterUiPermission`;

  //   return axiosInstance.post(apiUrl, data);
  // },

  // updateMasterUiPermissions: (data) => {
  //   // const apiUrl = `${baseurlauth}/User/UpdateMasterUiPermission`;
  //   const apiUrl = `${baseurl}/NetAuth/UpdateMasterUiPermission`;

  //   return axiosInstance.post(apiUrl, data);
  // },

  // exportAssignment: (data) => {
  //
  //   const apiUrl = `${baseurl}/Assignment/AssignmentImportFromCsv`;
  //   return axiosInstance.post(apiUrl, data);
  // }

  // exportAssignment: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/AssignmentImportFromCsv`;
  //   const config = {
  //     headers: {
  //       Accept: "text/plain",
  //       "Content-Type": "multipart/form-data",
  //     },
  //   };
  //   return axiosInstance.post(apiUrl, data, config);
  // },

  // updateMappedAssignment: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/InsertImportAssignmentRequest`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // getAssignmentBatchStatus: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/FetchBatchStatus?BatchId=${data}`;
  //   return axiosInstance.get(apiUrl, data);
  // },

  // getUnprocessedRecords: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/ImportAssignmentUnprocessedRecord?BatchId=${data}`;
  //   return axiosInstance.get(apiUrl, data);
  // },

  // updateUnprocessedRecords: (data) => {
  //   const apiUrl = `${baseurl}/Assignment/AddImportAssignmentUnprocessedRecord`;
  //   return axiosInstance.post(apiUrl, data);
  // },

  // createTimelog: (data) => {
  //   const apiUrl = `${baseurl}/UserTimelogSettings/Create`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getUserTimelogSettings: () => {
  //   const apiUrl = `${baseurl}/UserTimelogSettings/GetUserTimelogSettings`;
  //   return axiosInstance.get(apiUrl);
  // },
  // getUserTimelogSettingsById: (data) => {
  //   const apiUrl = `${baseurl}/UserTimelogSettings/GetUserTimelogSettings?userId=${data}`;
  //   return axiosInstance.get(apiUrl);
  // },
  // deleteTimelogSettings: (data) => {
  //   const apiUrl = `${baseurl}/UserTimelogSettings/Delete`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  addUserActivity: (data) => {
    // const apiUrl = `${baseurlauth}/User/AddUserActivity`;
    const apiUrl = `${baseurl}/NetAuth/AddUserActivity`;

    return axiosInstance.post(apiUrl, data);
  },
  // getUserActivity: (data) => {
  //   // const apiUrl = `${baseurlauth}/User/UserActivities?userId=${data.userId}`;
  //   const apiUrl = `${baseurl}/NetAuth/UserActivities?userId=${data.userId}`;

  //   return axiosInstance.get(apiUrl);
  // },

  // deleteTimesheet: (data) => {
  //   const apiUrl = `${baseurl}/Timesheet/Delete`;
  //   return axiosInstance.post(apiUrl, data);
  // },
  // getUserActivities: (data) => {
  //   // const apiUrl = `${baseurlauth}/User/GetUserActivitiesByUserIds`;
  //   const apiUrl = `${baseurl}/NetAuth/GetUserActivitiesByUserIds`;

  //   return axiosInstance.post(apiUrl, data);
  // },

  inActiveUser: (data) => {
    // const apiUrl = `${baseurlauth}/User/ActivateOrInActivateUser`;
    const apiUrl = `${baseurl}/NetAuth/ActivateOrInActivateUser`;

    return axiosInstance.post(apiUrl, data);
  },

  getLeadList: (data) => {
    const apiUrl = `${baseurl}/Lead/GetLeads`;
    return axiosInstance.post(apiUrl, data);
  },

  getLeadById: (data) => {
    const apiUrl = `${baseurl}/Lead/GetLeadById?id=${data}`;
    return axiosInstance.get(apiUrl);
  },

  importLead: (data, config) => {
    const apiUrl = `${baseurl}/Lead/ImportLeadFile`;
    return axiosInstance.post(apiUrl, data, config);
  },

  createLead: (data) => {
    const apiUrl = `${baseurl}/Lead/CreateLead`;
    return axiosInstance.post(apiUrl, data);
  },

  updateMultipleLeadFields: (data) => {
    const apiUrl = `${baseurl}/Lead/UpdateMultipleLead`;
    return axiosInstance.post(apiUrl, data);
  },

  updateLead: (data) => {
    const apiUrl = `${baseurl}/Lead/UpdateLead`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteLead: (data) => {
    const apiUrl = `${baseurl}/Lead/DeleteLead`;
    return axiosInstance.post(apiUrl, data);
  },

  convertLead: (data) => {
    const apiUrl = `${baseurl}/Lead/ConvertLead`;
    return axiosInstance.post(apiUrl, data);
  },
  updateEnrichedFlag: (data, moduleName) => {
    const apiUrl = `${baseurl}/${moduleName}/UpdateEnrichById`;
    return axiosInstance.post(apiUrl, data);
  },
  getEnrichedData(data) {
    const apiUrl = `${enrichUrl}/process`;
    return axiosInstance.post(apiUrl, data);
  },
  generateReport(data) {
    const apiUrl = `${enrichUrl}/createreport`;
    return axiosInstance.post(apiUrl, data);
  },
  updateGenerateReportFlag: (data, moduleName) => {
    const apiUrl = `${baseurl}/${moduleName}/UpdateAccountReportStatus`;
    return axiosInstance.post(apiUrl, data);
  },
  getNotesByModuleId: (data) => {
    const apiUrl = `${baseurl}/Note/GetNoteByModuleId?module=${data?.moduleName}&moduleId=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },
  getAttachmentsByModuleId: (data) => {
    const apiUrl = `${baseurl}/Attachments/GetAttachmentsByModuleId?module=${data?.moduleName}&moduleId=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },
  getCampaignsByModuleId: (data) => {
    const apiUrl = `${baseurl}/Campaign/GetCampaignByModule?module=${data?.moduleName}&moduleId=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },
  getLeadsByCampaignId: (data) => {
    const apiUrl = `${baseurl}/Lead/GetLeadByCampaignId?campaignId=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },
  getContactsByCampaignId: (data) => {
    const apiUrl = `${baseurl}/Contact/GetContactByCampaignId?campaignId=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },
  getEmailsByModuleId: (data) => {
    const apiUrl = `${baseurl}/Email/GetEmailsByModuleId?module=${data?.moduleName}&moduleId=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },
  getMassEmailsByModule: (data) => {
    const apiUrl = `${baseurl}/Email/GetMassEmailByModule`;
    return axiosInstance.post(apiUrl, data);
  },

  getTagsByModuleId: (data) => {
    const apiUrl = `${baseurl}/Tags/GetTagsByModuleId?module=${data?.moduleName}&moduleId=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },

  getContactList: (data) => {
    const apiUrl = `${baseurl}/Contact/GetContact`;
    return axiosInstance.post(apiUrl, data);
  },

  importContact: (data, config) => {
    const apiUrl = `${baseurl}/Contact/ImportContactFile`;
    return axiosInstance.post(apiUrl, data, config);
  },

  createContactList: (data) => {
    const apiUrl = `${baseurl}/Contact/CreateContact`;
    return axiosInstance.post(apiUrl, data);
  },

  updateContactList: (data) => {
    const apiUrl = `${baseurl}/Contact/UpdateContact`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteContact: (data) => {
    const apiUrl = `${baseurl}/Contact/DeleteContact`;
    return axiosInstance.post(apiUrl, data);
  },

  getAccountList: (data) => {
    const apiUrl = `${baseurl}/Account/GetAccount`;
    return axiosInstance.post(apiUrl, data);
  },
  importAccount: (data, config) => {
    const apiUrl = `${baseurl}/Account/ImportAccountFile`;
    return axiosInstance.post(apiUrl, data, config);
  },
  createAccountList: (data) => {
    const apiUrl = `${baseurl}/Account/CreateAccount`;
    return axiosInstance.post(apiUrl, data);
  },

  updateAccountList: (data) => {
    const apiUrl = `${baseurl}/Account/UpdateAccount`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteAccount: (data) => {
    const apiUrl = `${baseurl}/Account/DeleteAccount`;
    return axiosInstance.post(apiUrl, data);
  },

  getTicketList: (data) => {
    const apiUrl = `${baseurl}/Ticket/GetTicket`;
    return axiosInstance.post(apiUrl, data);
  },

  createTicketList: (data) => {
    const apiUrl = `${baseurl}/Ticket/CreateTicket`;
    return axiosInstance.post(apiUrl, data);
  },

  updateTicketList: (data) => {
    const apiUrl = `${baseurl}/Ticket/UpdateTicket`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteTicket: (data) => {
    const apiUrl = `${baseurl}/Ticket/DeleteTicket`;
    return axiosInstance.post(apiUrl, data);
  },

  getOpportunityList: (data) => {
    const apiUrl = `${baseurl}/Opportunity/GetOpportunity`;
    return axiosInstance.post(apiUrl, data);
  },

  createOpportunityList: (data) => {
    const apiUrl = `${baseurl}/Opportunity/CreateOpportunity`;
    return axiosInstance.post(apiUrl, data);
  },

  updateOpportunityList: (data) => {
    const apiUrl = `${baseurl}/Opportunity/UpdateOpportunity`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteOpportunity: (data) => {
    const apiUrl = `${baseurl}/Opportunity/DeleteOpportunity`;
    return axiosInstance.post(apiUrl, data);
  },

  importOpportunity: (data, config) => {
    const apiUrl = `${baseurl}/Opportunity/ImportOpportunityFile`;
    return axiosInstance.post(apiUrl, data, config);
  },

  getCampaignList: (data) => {
    const apiUrl = `${baseurl}/Campaign/GetCampaign`;
    return axiosInstance.post(apiUrl, data);
  },

  createCampaignList: (data) => {
    const apiUrl = `${baseurl}/Campaign/CreateCampaign`;
    return axiosInstance.post(apiUrl, data);
  },

  updateCampaignList: (data) => {
    const apiUrl = `${baseurl}/Campaign/UpdateCampaign`;
    return axiosInstance.post(apiUrl, data);
  },
  getCampaignById: (data) => {
    const apiUrl = `${baseurl}/Campaign/GetCampaignById?id=${data}`;
    return axiosInstance.get(apiUrl, data);
  },

  deleteCampaign: (data) => {
    const apiUrl = `${baseurl}/Campaign/DeleteCampaign`;
    return axiosInstance.post(apiUrl, data);
  },
  importCampaign: (data, config) => {
    const apiUrl = `${baseurl}/Campaign/ImportCampaignFile`;
    return axiosInstance.post(apiUrl, data, config);
  },

  getRevenueTypeList: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=RevenueType`;
    return axiosInstance.get(apiUrl);
  },
  getLeadSourceList: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=LeadSource`;
    return axiosInstance.get(apiUrl);
  },
  getIndustryList: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=Industry`;
    return axiosInstance.get(apiUrl);
  },

  getAccountType: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=AccountType`;
    return axiosInstance.get(apiUrl);
  },

  getTimeZone: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=TimeZone`;
    return axiosInstance.get(apiUrl);
  },

  getSalutation: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=Salutation`;
    return axiosInstance.get(apiUrl);
  },

  getCampaignType: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=CampaignType`;
    return axiosInstance.get(apiUrl);
  },

  getCampaignStatus: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=CampaignStatus`;
    return axiosInstance.get(apiUrl);
  },

  getTicketPriority: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=TicketPriorityCrm`;
    return axiosInstance.get(apiUrl);
  },

  getContactPersonRole: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=ContactPersonRole`;
    return axiosInstance.get(apiUrl);
  },

  getStage: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=Stage`;
    return axiosInstance.get(apiUrl);
  },

  getCampaignSource: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=CampaignSource`;
    return axiosInstance.get(apiUrl);
  },

  getCampaignMemberStatus: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=MemberStatusCrm`;
    return axiosInstance.get(apiUrl);
  },

  getTicketStatus: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=StatusCrm`;
    return axiosInstance.get(apiUrl);
  },

  getForecastCategory: () => {
    const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=ForecastCategory`;
    return axiosInstance.get(apiUrl);
  },

  getTotalLead: () => {
    const apiUrl = `${baseurl}/CrmDashboard/GetTotalLead`;
    return axiosInstance.get(apiUrl);
  },

  getTotalOpenTicket: () => {
    const apiUrl = `${baseurl}/CrmDashboard/TotalOpenTicket`;
    return axiosInstance.get(apiUrl);
  },

  getOpenOpportunity: () => {
    const apiUrl = `${baseurl}/CrmDashboard/GetOpenOpportunity`;
    return axiosInstance.get(apiUrl);
  },

  getCrmDashboard: () => {
    const apiUrl = `${baseurl}/CrmDashboard/GetCrmDashboard`;
    return axiosInstance.get(apiUrl);
  },

  getMeetingsList: (data) => {
    const apiUrl = `${baseurl}/Meetings/GetMeetings`;
    return axiosInstance.post(apiUrl, data);
  },

  getCallsList: (data) => {
    const apiUrl = `${baseurl}/Calls/GetCalls`;
    return axiosInstance.post(apiUrl, data);
  },
  deleteNote: (data) => {
    const apiUrl = `${baseurl}/Note/DeleteNote`;
    return axiosInstance.post(apiUrl, data);
  },

  createNote: (data) => {
    const apiUrl = `${baseurl}/Note/CreateNote`;
    return axiosInstance.post(apiUrl, data);
  },

  updateNote: (data) => {
    const apiUrl = `${baseurl}/Note/UpdateNote`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteCampaignByModule: (data) => {
    const apiUrl = `${baseurl}/Campaign/DeleteCampaignByModule`;
    return axiosInstance.post(apiUrl, data);
  },

  createAttachment: (data) => {
    const apiUrl = `${baseurl}/Attachments/CreateAttachments`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteAttachment: (data) => {
    const apiUrl = `${baseurl}/Attachments/DeleteAttachments`;
    return axiosInstance.post(apiUrl, data);
  },

  addCampaignFromLead: (data) => {
    const apiUrl = `${baseurl}/Lead/AddCampaign`;
    return axiosInstance.post(apiUrl, data);
  },

  addCampaignFromContact: (data) => {
    const apiUrl = `${baseurl}/Contact/AddCampaign`;
    return axiosInstance.post(apiUrl, data);
  },

  addCampaignFromAccount: (data) => {
    const apiUrl = `${baseurl}/Account/AddCampaign`;
    return axiosInstance.post(apiUrl, data);
  },

  addCampaignFromOpportunity: (data) => {
    const apiUrl = `${baseurl}/Opportunity/AddCampaign`;
    return axiosInstance.post(apiUrl, data);
  },

  updateCampaignByModule: (data) => {
    const apiUrl = `${baseurl}/Campaign/UpdateCampaignByModule`;
    return axiosInstance.post(apiUrl, data);
  },

  updateMultipleContactField: (data) => {
    const apiUrl = `${baseurl}/Contact/UpdateMultipleContact`;
    return axiosInstance.post(apiUrl, data);
  },

  updateMultipleAccountField: (data) => {
    const apiUrl = `${baseurl}/Account/UpdateMultipleAccount`;
    return axiosInstance.post(apiUrl, data);
  },

  updateMultipleOpportunityField: (data) => {
    const apiUrl = `${baseurl}/Opportunity/UpdateMultipleOpportunity`;
    return axiosInstance.post(apiUrl, data);
  },

  updateMultipleCampaignField: (data) => {
    const apiUrl = `${baseurl}/Campaign/UpdateMultipleCampaign`;
    return axiosInstance.post(apiUrl, data);
  },

  updateTags: (data) => {
    const apiUrl = `${baseurl}/Tags/Update`;
    return axiosInstance.post(apiUrl, data);
  },

  createTags: (data) => {
    const apiUrl = `${baseurl}/Tags/CreateTags`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteTagsByModuleId: (data) => {
    const apiUrl = `${baseurl}/Tags/DeleteTagsByModuleId`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteTagsByModule: (data) => {
    const apiUrl = `${baseurl}/Tags/DeleteTagsByModule`;
    return axiosInstance.post(apiUrl, data);
  },

  getTagsByModule: (data) => {
    const apiUrl = `${baseurl}/Tags/GetTagsByModule`;
    return axiosInstance.post(apiUrl, data);
  },

  // getIndustryList: (type) => {
  //   const apiUrl = `${baseurl}/Master/GetGenericMasterTable?type=${type}`;
  //   return axiosInstance.get(apiUrl);
  // },
  sendEmail: (data) => {
    const apiUrl = `${baseurl}/Email/CreateEmails`;
    return axiosInstance.post(apiUrl, data);
  },
  sendMassEmail: (data) => {
    const apiUrl = `${baseurl}/Email/CreateMultipleEmail`;
    return axiosInstance.post(apiUrl, data);
  },
  // getEmailByModule: (moduleId, module) => {
  //   const apiUrl = `${baseurl}/Email/GetEmailsByModuleId?ModuleId=${moduleId}&Module=${module}`;
  //   return axiosInstance.get(apiUrl);
  // },
  deleteEmail: (data) => {
    const apiUrl = `${baseurl}/Email/DeleteEmails`;
    return axiosInstance.post(apiUrl, data);
  },
  updateEmail: (data) => {
    const apiUrl = `${baseurl}/Email/UpdateEmails`;
    return axiosInstance.post(apiUrl, data);
  },
  getEmailsById: (id) => {
    const apiUrl = `${baseurl}/Email/GetEmailsById?id=${id}`;
    return axiosInstance.get(apiUrl);
  },
  createTemplate: (data) => {
    const apiUrl = `${baseurl}/Template/CreateTemplate`;
    return axiosInstance.post(apiUrl, data);
  },
  updateTemplate: (data) => {
    const apiUrl = `${baseurl}/Template/UpdateTemplate`;
    return axiosInstance.post(apiUrl, data);
  },
  getAllTemplate: () => {
    const apiUrl = `${baseurl}/Template/GetTemplate`;
    return axiosInstance.get(apiUrl);
  },
  getTemplateByModule: (module) => {
    // const apiUrl = `${baseurl}/Template/GetTemplateByModule?associatedModule=${module}`;
    const apiUrl = `${baseurl}/Template/GetTemplateByModule`;
    const data = {
      module: `${module}`,
      // templateType: [
      //   "Basic",
      //   "Sample",
      //   "Celebration",
      //   "Invitation",
      //   "Follow-up",
      //   "Product Promotion",
      //   "Notification",
      // ],
      templateType: [
        'AI Agent',
        'AQ',
        'AS400',
        'BPO',
        'Claims',
        'Digital Transformation',
        'IT Services',
        'Newsletter',
        'RPA',
        'Event',
      ],
    };
    return axiosInstance.post(apiUrl, data);
  },
  getLeadImageCRM: async (imgUrl) => {
    const blobServiceClient = new BlobServiceClient(sasUrl);

    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blobClient = containerClient.getBlobClient(imgUrl);

    const downloadBlockBlobResponse = await blobClient.download(0);
    const blobContent = await downloadBlockBlobResponse.blobBody;

    // Convert blob content to a URL for display
    const objectURL = URL.createObjectURL(blobContent);
    return objectURL;
  },
  uploadLeadImageCRM: async (imagefile, module) => {
    const blobServiceClient = new BlobServiceClient(sasUrl);
    const containerClient = blobServiceClient.getContainerClient(containerName);

    try {
      // Create a blob client with the desired folder name and file name
      const blockBlobClient = containerClient.getBlockBlobClient(
        `${module}/${imagefile.name}` // Add the folder name here
      );
      // Upload the file
      await blockBlobClient.uploadBrowserData(imagefile); // Pass the file data here
      return true;
    } catch (error) {
      console.error('Error uploading file:', error.message);
      alert('File upload failed. See console for details.');
      return false;
    }
  },
  deleteLeadImageCRM: async (fileName) => {
    const blobServiceClient = new BlobServiceClient(sasUrl);
    const containerClient = blobServiceClient.getContainerClient(containerName);

    try {
      // Create a blob client for the specific file
      const blockBlobClient = containerClient.getBlockBlobClient(`Lead/${fileName}`);

      // Delete the blob
      await blockBlobClient.delete();

      console.log(`${fileName} deleted successfully from Leads folder.`);
      return true;
    } catch (error) {
      console.error('Error deleting file:', error.message);
      alert('File deletion failed. See console for details.');
      return false;
    }
  },
  // getFileCRM: async (fileName) => {
  //   const blobServiceClient = new BlobServiceClient(sasUrl);

  //   const containerClient =
  //     blobServiceClient.getContainerClient(containerName);
  //   const blobClient = containerClient.getBlobClient(fileName);

  //   const downloadBlockBlobResponse = await blobClient.download(0);
  //   const blobContent = await downloadBlockBlobResponse.blobBody;

  //   // Convert blob content to a URL for display
  //   const objectURL = URL.createObjectURL(blobContent);
  //   return objectURL;
  // },
  previewFileCRM: async (fileName, folderName) => {
    const blobServiceClient = new BlobServiceClient(sasUrl);
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(`${folderName}/${fileName}`);

    try {
      const downloadBlockBlobResponse = await blockBlobClient.download();
      const blob = await downloadBlockBlobResponse.blobBody;
      return blob;
    } catch (error) {
      console.error('Error previewing file:', error.message);
    }
  },
  downloadFileCRM: async (fileName, folderName, newFileName) => {
    const blobServiceClient = new BlobServiceClient(sasUrl);
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(`${folderName}/${fileName}`);

    try {
      const downloadBlockBlobResponse = await blockBlobClient.download();
      const blob = await downloadBlockBlobResponse.blobBody;
      const downloadUrl = URL.createObjectURL(blob);

      // Create a link element and set the desired filename
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = newFileName || fileName; // Use the new filename if provided
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading file:', error.message);
    }
  },
  uploadFilesCRM: async (files, folderName) => {
    const blobServiceClient = new BlobServiceClient(sasUrl);
    const containerClient = blobServiceClient.getContainerClient(containerName);

    try {
      // Use Promise.all to upload all files simultaneously
      const uploadPromises = Array.from(files).map(async (file) => {
        const blockBlobClient = containerClient.getBlockBlobClient(`${folderName}/${file.name}`);
        await blockBlobClient.uploadBrowserData(file);
      });

      // Wait for all uploads to complete
      await Promise.all(uploadPromises);
      console.log('All files uploaded successfully.');
      return true;
    } catch (error) {
      console.error('Error uploading files:', error.message);
      alert('Some or all file uploads failed. See console for details.');
      return false;
    }
  },
  uploadFileCRM: async (file, folderName) => {
    const blobServiceClient = new BlobServiceClient(sasUrl);
    const containerClient = blobServiceClient.getContainerClient(containerName);

    try {
      // Create a blob client with the desired folder name and file name
      const blockBlobClient = containerClient.getBlockBlobClient(
        `Attachments/${file.name}` // Add the folder name here
      );
      // Upload the file
      await blockBlobClient.uploadBrowserData(file); // Pass the file data here
      return true;
    } catch (error) {
      console.error('Error uploading file:', error.message);
      alert('File upload failed. See console for details.');
      return false;
    }
  },
  deleteFileCRM: async (fileName) => {
    const blobServiceClient = new BlobServiceClient(sasUrl);
    const containerClient = blobServiceClient.getContainerClient(containerName);

    try {
      // Create a blob client for the specific file
      const blockBlobClient = containerClient.getBlockBlobClient(`Attachments/${fileName}`);

      // Delete the blob
      await blockBlobClient.delete();

      console.log(`${fileName} deleted successfully from Attachments folder.`);
      return true;
    } catch (error) {
      console.error('Error deleting file:', error.message);
      alert('File deletion failed. See console for details.');
      return false;
    }
  },

  getModuleTimeline: (data) => {
    const apiUrl = `${baseurl}/Timeline/GetTimelineByModuleIdandModuleType?moduleId=${data.moduleId}&moduleType=${data.moduleType}`;
    return axiosInstance.get(apiUrl, data);
  },
  deleteTemplate: (data) => {
    const apiUrl = `${baseurl}/Template/DeleteTemplate`;
    return axiosInstance.post(apiUrl, data);
  },

  getOpportunityByModule: (data) => {
    const apiUrl = `${baseurl}/Opportunity/GetOpportunityByModuleId?module=${data?.moduleName}&moduleId=${data?.id}`;
    return axiosInstance.get(apiUrl, data);
  },

  getContactByModule: (data) => {
    const apiUrl = `${baseurl}/Contact/GetContactByModuleId?module=${data?.moduleName}&moduleId=${data?.id}`;
    return axiosInstance.get(apiUrl, data);
  },
  getContactByCampaign: (data) => {
    const apiUrl = `${baseurl}/Contact/GetContactByCampaignId?module=${data?.moduleName}&campaignId=${data?.id}`;
    return axiosInstance.get(apiUrl, data);
  },
  getChildAccountByParentAccountId: (data) => {
    const apiUrl = `${baseurl}/Account/GetChildAccountByParentAccountId?parentAccountId=${data?.id}`;
    return axiosInstance.get(apiUrl, data);
  },
  exportAllLead: (data) => {
    const apiUrl = `${baseurl}/Lead/ExportLead`;
    return axiosInstance.post(apiUrl, data);
  },
  exportAllAccount: (data) => {
    const apiUrl = `${baseurl}/Account/ExportAccount`;
    return axiosInstance.post(apiUrl, data);
  },
  exportAllContact: (data) => {
    const apiUrl = `${baseurl}/Contact/ExportContact`;
    return axiosInstance.post(apiUrl, data);
  },
  exportAllOpportunity: (data) => {
    const apiUrl = `${baseurl}/Opportunity/ExportOpportunity`;
    return axiosInstance.post(apiUrl, data);
  },
  exportAllCampaign: (data) => {
    const apiUrl = `${baseurl}/Campaign/ExportCampaign`;
    return axiosInstance.post(apiUrl, data);
  },
  exportAllTicket: (data) => {
    const apiUrl = `${baseurl}/Ticket/ExportTicket`;
    return axiosInstance.post(apiUrl, data);
  },
  exportEmail: (data) => {
    const apiUrl = `${baseurl}/Email/ExportEmail`;
    return axiosInstance.post(apiUrl, data);
  },
  exportAllQuote: (data) => {
    const apiUrl = `${baseurl}/Quote/ExportQuote`;
    return axiosInstance.post(apiUrl, data);
  },
  exportAllSales: (data) => {
    const apiUrl = `${baseurl}/SaleOrder/ExportSaleOrder`;
    return axiosInstance.post(apiUrl, data);
  },
  exportAllInvoice: (data) => {
    const apiUrl = `${baseurl}/Invoice/ExportInvoice`;
    return axiosInstance.post(apiUrl, data);
  },
  exportAllProduct: (data) => {
    const apiUrl = `${baseurl}/Product/ExportProduct`;
    return axiosInstance.post(apiUrl, data);
  },
  exportAllPriceSheet: (data) => {
    const apiUrl = `${baseurl}/PriceSheet/ExportPriceSheet`;
    return axiosInstance.post(apiUrl, data);
  },
  getAccountsDropdown: (data) => {
    const apiUrl = `${baseurl}/Account/GetNamesList`;
    return axiosInstance.post(apiUrl, data);
  },
  getLeadsDropdown: (data) => {
    const apiUrl = `${baseurl}/Lead/GetNamesList`;
    return axiosInstance.post(apiUrl, data);
  },
  getContactsDropdown: (data) => {
    const apiUrl = `${baseurl}/Contact/GetNamesList`;
    return axiosInstance.post(apiUrl, data);
  },
  getOpportunityDropdown: (data) => {
    const apiUrl = `${baseurl}/Opportunity/GetNamesList`;
    return axiosInstance.post(apiUrl, data);
  },
  getCampaignDropdown: (data) => {
    const apiUrl = `${baseurl}/Campaign/GetNamesList`;
    return axiosInstance.post(apiUrl, data);
  },
  getProductDropdown: (data) => {
    const apiUrl = `${baseurl}/Product/GetNameList`;
    return axiosInstance.post(apiUrl, data);
  },

  createQuote: (data) => {
    const apiUrl = `${baseurl}/Quote/CreateQuote`;
    return axiosInstance.post(apiUrl, data);
  },
  getQuoteList: (data) => {
    const apiUrl = `${baseurl}/Quote/Getlist`;
    return axiosInstance.post(apiUrl, data);
  },
  getQuoteById: (data) => {
    const apiUrl = `${baseurl}/Quote/GetById?id=${data}`;
    return axiosInstance.get(apiUrl);
  },
  updateQuote: (data) => {
    const apiUrl = `${baseurl}/Quote/Update`;
    return axiosInstance.post(apiUrl, data);
  },

  stopORStartCampaign: (data) => {
    const apiUrl = `${baseurl}/Campaign/StopOrResumeCampaign`;
    return axiosInstance.post(apiUrl, data);
  },

  getProductList: (data) => {
    const apiUrl = `${baseurl}/Product/Getlist`;
    return axiosInstance.post(apiUrl, data);
  },

  createProduct: (data) => {
    const apiUrl = `${baseurl}/Product/Create`;
    return axiosInstance.post(apiUrl, data);
  },

  updateProduct: (data) => {
    const apiUrl = `${baseurl}/Product/Update`;
    return axiosInstance.post(apiUrl, data);
  },

  getProductById: (data) => {
    const apiUrl = `${baseurl}/Product/GetById?id=${data}`;
    return axiosInstance.get(apiUrl);
  },

  sendNow: (data) => {
    const apiUrl = `${baseurl}/Campaign/SendCampaignImmediately`;
    return axiosInstance.post(apiUrl, data);
  },

  getSalesOrder: (data) => {
    const apiUrl = `${baseurl}/SaleOrder/GetSaleOrders`;
    return axiosInstance.post(apiUrl, data);
  },

  createSalesOrder: (data) => {
    const apiUrl = `${baseurl}/SaleOrder/AddSaleOrder`;
    return axiosInstance.post(apiUrl, data);
  },

  updateSalesOrder: (data) => {
    const apiUrl = `${baseurl}/SaleOrder/UpdateSaleOrder`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteSalesOrder: (data) => {
    const apiUrl = `${baseurl}/SaleOrder/DeleteSaleOrder`;
    return axiosInstance.post(apiUrl, data);
  },

  getSalesOrderById: (data) => {
    const apiUrl = `${baseurl}/SaleOrder/GetSaleOrderById?id=${data}`;
    return axiosInstance.get(apiUrl, data);
  },

  getSaleOrderDetailList: (data) => {
    const apiUrl = `${baseurl}/SaleOrderDetail/GetSaleOrderDetailList`;
    return axiosInstance.post(apiUrl, data);
  },

  getSalesOrderDetailsById: (data) => {
    const apiUrl = `${baseurl}/SaleOrderDetail/GetBySaleOrderId?saleOrderId=${data?.id}`;
    return axiosInstance.get(apiUrl, data);
  },

  getSalesOrderDetailsDeleteById: (data) => {
    const apiUrl = `${baseurl}/SaleOrderDetail/DeleteSaleOrderDetail`;
    return axiosInstance.post(apiUrl, data);
  },

  updateSalesOrderDetailsById: (data) => {
    const apiUrl = `${baseurl}/SaleOrderDetail/UpdateMultipleSaleOrderDetail`;
    return axiosInstance.post(apiUrl, data);
  },

  getInvoice: (data) => {
    const apiUrl = `${baseurl}/Invoice/GetInvoices`;
    return axiosInstance.post(apiUrl, data);
  },

  getQuoteByAccountId: (data) => {
    const apiUrl = `${baseurl}/Quote/GetByAccountId?accountId=${data}`;
    return axiosInstance.get(apiUrl, data);
  },

  getSalesOwnerByQuoteAndAccountId: (data) => {
    const apiUrl = `${baseurl}/SaleOrder/GetByQuoteIdAndAccountId?quoteId=${data?.quoteId}&accountId=${data?.accountId}`;
    return axiosInstance.get(apiUrl, data);
  },

  createInvoice: (data) => {
    const apiUrl = `${baseurl}/Invoice/CreateInvoice`;
    return axiosInstance.post(apiUrl, data);
  },

  updateInvoice: (data) => {
    const apiUrl = `${baseurl}/Invoice/UpdateInvoice`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteInvoice: (data) => {
    const apiUrl = `${baseurl}/Invoice/DeleteInvoice`;
    return axiosInstance.post(apiUrl, data);
  },

  getInvoiceById: (data) => {
    const apiUrl = `${baseurl}/Invoice/GetInvoiceById?id=${data}`;
    return axiosInstance.get(apiUrl, data);
  },

  getInvoiceSalesOrderDetails: (data) => {
    const apiUrl = `${baseurl}/InvoiceDetail/GetByInvoiceId?invoiceId=${data?.id}`;
    return axiosInstance.get(apiUrl, data);
  },

  getInvoiceSalesOrderDetailsDeleteById: (data) => {
    const apiUrl = `${baseurl}/InvoiceDetail/DeleteInvoiceDetail`;
    return axiosInstance.post(apiUrl, data);
  },

  deleteProduct: (data) => {
    const apiUrl = `${baseurl}/Product/Delete`;
    return axiosInstance.post(apiUrl, data);
  },

  getPriceList: (data) => {
    const apiUrl = `${baseurl}/PriceSheet/Getlist`;
    return axiosInstance.post(apiUrl, data);
  },

  createPrice: (data) => {
    const apiUrl = `${baseurl}/PriceSheet/Create`;
    return axiosInstance.post(apiUrl, data);
  },

  updatePrice: (data) => {
    const apiUrl = `${baseurl}/PriceSheet/Update`;
    return axiosInstance.post(apiUrl, data);
  },

  deletePrice: (data) => {
    const apiUrl = `${baseurl}/PriceSheet/Delete`;
    return axiosInstance.post(apiUrl, data);
  },
  getAccountById: (data) => {
    const apiUrl = `${baseurl}/Account/GetAccountById?id=${data}`;
    return axiosInstance.get(apiUrl);
  },
  getContactById: (data) => {
    const apiUrl = `${baseurl}/Contact/GetContactById?id=${data}`;
    return axiosInstance.get(apiUrl);
  },
  getOpportunityById: (data) => {
    const apiUrl = `${baseurl}/Opportunity/GetOpportunityById?id=${data}`;
    return axiosInstance.get(apiUrl);
  },
  getTicketById: (data) => {
    const apiUrl = `${baseurl}/Ticket/GetTicketById?id=${data}`;
    return axiosInstance.get(apiUrl);
  },
  getPriceListById: (data) => {
    const apiUrl = `${baseurl}/PriceSheet/GetById?id=${data}`;
    return axiosInstance.get(apiUrl);
  },
  productPricesheetAssociation: (data) => {
    const apiUrl = `${baseurl}/ProductPriceSheetAssociation/Add`;
    return axiosInstance.post(apiUrl, data);
  },
  deletePricesheetFromProduct: (data) => {
    const apiUrl = `${baseurl}/ProductPriceSheetAssociation/Delete`;
    return axiosInstance.post(apiUrl, data);
  },
  getProductByPricesheetId: (data) => {
    const apiUrl = `${baseurl}/ProductPriceSheetAssociation/GetProductsByPriceSheetId?priceSheetId=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },
  getAccountByPricesheetId: (data) => {
    const apiUrl = `${baseurl}/AccountPriceSheetAssociation/GetAccountsByPriceSheetId?priceSheetId=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },
  accountPriceSheetAssociation: (data) => {
    const apiUrl = `${baseurl}/AccountPriceSheetAssociation/Add`;
    return axiosInstance.post(apiUrl, data);
  },
  deleteAccountFromPriceSheet: (data) => {
    const apiUrl = `${baseurl}/AccountPriceSheetAssociation/Delete`;
    return axiosInstance.post(apiUrl, data);
  },
  getProductPricesheetAssociationById: (data) => {
    const apiUrl = `${baseurl}/ProductPriceSheetAssociation/GetProductPriceSheetAssociationById?id=${data}`;
    return axiosInstance.get(apiUrl);
  },
  getPricesheetListByAccountId: (data) => {
    const apiUrl = `${baseurl}/PriceSheet/GetListByAccountId?id=${data}`;
    return axiosInstance.get(apiUrl);
  },
  getQuoteDetailsByQuoteId: (data) => {
    const apiUrl = `${baseurl}/QuoteDetail/GetByQuoteId?id=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },
  updateMultipleQuoteDetails: (data) => {
    const apiUrl = `${baseurl}/QuoteDetail/UpdateMultipleQuoteDetail`;
    return axiosInstance.post(apiUrl, data);
  },
  accountProductAssociation: (data) => {
    const apiUrl = `${baseurl}/ProductAccountAssociation/Add`;
    return axiosInstance.post(apiUrl, data);
  },
  getAccountsByProductId: (data) => {
    const apiUrl = `${baseurl}/ProductAccountAssociation/GetAccountsByProductId?productId=${data?.id}`;
    return axiosInstance.get(apiUrl);
  },
  deleteAccountFromProduct: (data) => {
    const apiUrl = `${baseurl}/ProductAccountAssociation/Delete`;
    return axiosInstance.post(apiUrl, data);
  },
  getProductsByAccountId: (data) => {
    const apiUrl = `${baseurl}/ProductAccountAssociation/GetProductsByAccountId?accountId=${data}`;
    return axiosInstance.get(apiUrl);
  },
  getPriceSheetsByProductId: (data) => {
    const apiUrl = `${baseurl}/ProductPriceSheetAssociation/GetPriceSheetsByProductId?productId=${data}`;
    return axiosInstance.get(apiUrl);
  },
  updateProductPriceSheetAssociation: (data) => {
    const apiUrl = `${baseurl}/ProductPriceSheetAssociation/Update`;
    return axiosInstance.post(apiUrl, data);
  },
  getProductReferenceLookup: (data) => {
    const apiUrl = `${baseurl}/Product/GetProductReferenceLookup`;
    return axiosInstance.post(apiUrl, data);
  },
  getQuotePdf: (data) => {
    const apiUrl = `${baseurl}/Quote/GetQuotePdf`;
    return axiosInstance.post(apiUrl, data, { responseType: 'blob' });
  },
  sendEmailForQuotePdf: (data) => {
    const apiUrl = `${baseurl}/Quote/SendEmailForQuotePdf`;
    return axiosInstance.post(apiUrl, data);
  },
  getSalesOrderPdf: (data) => {
    const apiUrl = `${baseurl}/SaleOrder/GetSaleOrderPdf`;
    return axiosInstance.post(apiUrl, data, { responseType: 'blob' });
  },
  sendEmailForSalesOrderPdf: (data) => {
    const apiUrl = `${baseurl}/SaleOrder/SendEmailForSaleOrderPdf`;
    return axiosInstance.post(apiUrl, data);
  },
  getInvoicePdf: (data) => {
    const apiUrl = `${baseurl}/Invoice/GetInvoicePdf`;
    return axiosInstance.post(apiUrl, data, { responseType: 'blob' });
  },
  sendEmailForInvoicePdf: (data) => {
    const apiUrl = `${baseurl}/Invoice/SendEmailForInvoicePdf`;
    return axiosInstance.post(apiUrl, data);
  },
  getInvoicePdf: (data) => {
    const apiUrl = `${baseurl}/Invoice/GetInvoicePdf`;
    return axiosInstance.post(apiUrl, data, { responseType: 'blob' });
  },
  updateMultipleInvoiceDetails: (data) => {
    const apiUrl = `${baseurl}/InvoiceDetail/UpdateMultipleInvoiceDetail`;
    return axiosInstance.post(apiUrl, data);
  },
  isDomainExist: (data) => {
    const apiUrl = `${baseurl}/Campaign/IsDomainExist`;
    return axiosInstance.post(apiUrl, data);
  },
  getAccessToken: (data) => {
    const apiUrl = `${baseurl}/Campaign/GetAccessToken`;
    return axiosInstance.post(apiUrl, data);
  },
  createSmartSquence: (data) => {
    const apiUrl = `${baseurl}/SmartSequence/AddSequenceDetails`;
    return axiosInstance.post(apiUrl, data);
  },
  getSmartSequence: (data) => {
    const apiUrl = `${baseurl}/SmartSequence/GetSequenceDetails`;
    return axiosInstance.post(apiUrl, data);
  },
  getSmartSequenceById: (data) => {
    const apiUrl = `${baseurl}/SmartSequence/GetSequenceDetailsById`;
    return axiosInstance.post(apiUrl, data);
  },
  updateSmartSequence: (data) => {
    const apiUrl = `${baseurl}/SmartSequence/UpdateSequenceDetails`;
    return axiosInstance.post(apiUrl, data);
  },
  deleteSmartSequence: (data) => {
    const apiUrl = `${baseurl}/SmartSequence/DeleteSequenceDetails`;
    return axiosInstance.post(apiUrl, data);
  },
  smartSequenceAudienceFilter: (data) => {
    const apiUrl = `${baseurl}/SmartSequence/UpsertAudienceFilterBySequenceId`;
    return axiosInstance.post(apiUrl, data);
  },
  SmartSequenceGetSequenceDetailsById: (data) => {
    const apiUrl = `${baseurl}/SmartSequence/GetSequenceDetailsById`;
    return axiosInstance.post(apiUrl, data);
  },
  smartSequenceEmailSteps: (data) => {
    const apiUrl = `${baseurl}/SmartSequence/UpsertEmailSequenceBySequenceId`;
    return axiosInstance.post(apiUrl, data);
  },
  getEmailSequencebySequenceId: (data) => {
    const apiUrl = `${baseurl}/SmartSequence/GetEmailSequenceBySequenceId`;
    return axiosInstance.post(apiUrl, data);
  },
  getZohoCampaigns: () => {
    const apiUrl = `${baseurl}/Campaign/GetZohoCampaigns`;
    return axiosInstance.get(apiUrl);
  },
  getAuditLogs: (data) => {
    const apiUrl = `${baseurl}/PublishEventData/Getlist`;
    return axiosInstance.post(apiUrl,data);
  },
  registerUser: (data) => {
    const apiUrl = `${baseurlauth}register`;
    return axios.post(apiUrl, data);
  },
    loginByDB: (data) => {
    const apiUrl = `${baseurlauth}login`;
    return axios.post(apiUrl, data);
  },
  updatePassword: (data) => {
    const apiUrl = `${baseurl}/NetAuth/UpdateUserPasswordHash`;
    return axiosInstance.post(apiUrl, data);
  },
    refreshToken: (data) => {
    const apiUrl = `${baseurlauth}refreshToken`;
    return axios.post(apiUrl, data);
  },
    revokeToken: (data) => {
    const apiUrl = `${baseurlauth}revoke`;
    return axios.post(apiUrl, data);
  },
    createAttendance: (data) => {
    const apiUrl = `${baseurl}/UserAttendance/Create`;
    return axiosInstance.post(apiUrl, data);
  },
    getAttendanceByUserId: (data) => {
    const apiUrl = `${baseurl}/UserAttendance/GetUserAttendanceByUserId?userId=${data}`;
    return axiosInstance.get(apiUrl, data);
  },
};
export default apiServices;
